module.exports = __webpack_public_path__ + "media/images/illustrations/undraw_celebration-26a0c9afc77d368176aa03b9f3878aa2.svg";